<template>
    <footer>
    <cookie-law buttonText="Accept">
      <div slot="message">
        This website uses cookies to provide you with a great user experience. By using it, you accept our <router-link to="cookie-policy">use of cookies</router-link>
      </div>
    </cookie-law>
    <div class="footer-widget-section">
        <div class="footer-overlay">
            <div class="container">
                <div class="row">
                    <!-- <div class="col-md-3 col-xs-6">
                        <div class="footer-widget about-us">
                            <div class="footer-widget-title">
                                <h2>about us</h2>
                            </div>
                            <div class="footer-widget-text margin-bottom20">
                                <p>
                                  Our Financial Statements Translation Tool ("FSTT") was developed to provide an instant and cost-effective translation financial statements belonging to corporate entities based in the Russian Federation.
                                </p>
                            </div>

                            <div class="address margin-bottom20 ul-li">
                                <ul>
                                    <li class="address"><a href="#"><i class="icon_pin_alt"></i>35 North Road, NY</a></li>
                                    <li class="phone"><a href="#"><i class="icon_phone"></i>+(550) 325 2567</a></li>
                                    <li class="mail"><a href="#"><i class="icon_mail_alt"></i>info@sitename.com</a></li>
                                </ul>
                            </div>

                            <div class="social ul-li">
                                <ul>
                                    <li><a href=""><i class="social_facebook"></i></a></li>
                                    <li><a href=""><i class="social_twitter"></i></a></li>
                                    <li><a href=""><i class="social_googleplus"></i></a></li>
                                    <li><a href=""><i class="social_tumblr"></i></a></li>
                                </ul>
                            </div>

                        </div>
                    </div> -->
                    <!-- col-md-3 col-sm-6 -->

                    <div class="col-md-3 col-xs-6">
                        <div class="footer-widget widget-link-list">
                            <div class="footer-widget-title">
                                <h2>quick links</h2>
                            </div>
                            <div class="quick-link ul-li">
                                <ul>
                                    <li><a :href="baseUrl"><i class="arrow_carrot-2right"></i>Home</a></li>
                                    <li><a :href="baseUrl+'#products'"><i class="arrow_carrot-2right"></i>Products</a></li>
                                    <li><a :href="baseUrl+'#pricing'"><i class="arrow_carrot-2right"></i>Pricing</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- col-md-3 col-sm-6 -->
                    <div class="col-md-3 col-xs-6">
                        <div class="footer-widget widget-link-list">
                            <div class="footer-widget-title">
                                <h2>&nbsp;</h2>
                            </div>
                            <div class="quick-link ul-li">
                                <ul>
                                    <li> <a :href="baseUrl+ '/faqs'"><i class="arrow_carrot-2right"></i>FAQ</a></li>
                                    <li><a :href="baseUrl+ '#testimonial'"><i class="arrow_carrot-2right"></i>Contact Us</a></li>
                                    <li><a :href="baseUrl+ '/our-customers'"><i class="arrow_carrot-2right"></i>Customers</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- col-md-3 col-sm-6 -->
                    <div class="col-md-3 col-xs-6">
                        <div class="footer-widget widget-link-list">
                            <div class="footer-widget-title">
                                <h2>&nbsp;</h2>
                            </div>
                            <div class="quick-link ul-li">
                                <ul>
                                    <li><a :href="baseUrl+ '/about'"><i class="arrow_carrot-2right"></i>About Us</a></li>
                                    <li><a :href="baseUrl+ '/disclaimer'"><i class="arrow_carrot-2right"></i>Disclaimer</a></li>
                                    <li><a :href="baseUrl+ '/terms-and-conditions'"><i class="arrow_carrot-2right"></i>Terms of Use</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- col-md-3 col-sm-6 -->
                    <div class="col-md-3 col-xs-6">
                        <div class="footer-widget widget-link-list">
                            <div class="footer-widget-title">
                                <h2>&nbsp;</h2>
                            </div>
                            <div class="quick-link ul-li">
                                <ul>
                                    <li><a :href="baseUrl+'/tandcsales'"><i class="arrow_carrot-2right"></i>Terms of Sale</a></li>
                                    <li><a :href="baseUrl+'/privacy-policy'"><i class="arrow_carrot-2right"></i>Privacy Policy</a></li>
                                    <li><a :href="baseUrl+'/cookie-policy'"><i class="arrow_carrot-2right"></i>Cookie Policy</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom">
        <div class="container">
            <!-- <div class="footer-menu ul-li">
                <ul>
                  <li v-for="menu in menus" :key="menu.name">
                    <a :href="menu.link">{{menu.name}}</a>
                    <ul v-if="menu.hasChild" class="dropdown-menu">
                      <li v-for="child in menu.childs" :key="child.name">
                        <a :href="child.link">{{child.name}}</a>
                      </li>
                    </ul>
                  </li>
                </ul>
            </div> -->
            <div class="Copyright">
                <p>&copy; {{year}} All rights reserved</p>
            </div>
        </div>
    </div>
</footer>
    <!-- <div>
        <footer class="footer-primary">
      <ul class="list-unstyled float-right">
        <li>Terms and conditions</li>
        <li>Privacy policy </li>
        <li>© {{year}} All rights reserved</li>
      </ul>
    </footer>
    </div> -->
</template>

<script>
import { mapState } from 'vuex'
import CookieLaw from 'vue-cookie-law'
export default {
  data: function () {
    return {
      year: new Date().getFullYear(),
      baseUrl: process.env.HOST
    }
  },
  components: { CookieLaw },
  computed: {
    ...mapState({
      menus: state => state.menus
    })
  },
  methods: {
    redirect (path) {
      this.$router.push({ path: `${this.baseUrl}` })
    }
  }
}
</script>

<style>
.footer-primary {
  display: block;
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/GuestFooter.vue